
<template>
  <b-container fluid>
    <b-row class="text-center">
      <b-col cols="12">
        <img :src="imageQr" alt="qr" v-if="qr !== null" :style="`margin-top: ${qrMarginTop}`"/>
        <p v-else>Cargando...</p>
      </b-col>
      <div id="lock-passport-window" v-if="lockPassport && locked">
        <div class="lock-passport-content" :style="`margin-top: ${qrMarginTop}`">
          <p>{{ unlockText }}</p>
        </div>
      </div>
    </b-row>
  </b-container>
</template>

<script>
  import io from 'socket.io-client'
  import Config from '../config/app.json'

  export default {
    name: 'Passport',
    data () {
      return {
        qr: null,
        locked: true
      }
    },
    created () {
      this.listenSocketEvents()
    },
    methods: {
      listenSocketEvents () {
        const socket = io(`${Config.socketUrl}`)

        this._listenUpdateQr(socket)

        if (!this.lockPassport) {
          return
        }

        this._listenLockPassport(socket)
      },
      _listenUpdateQr (socket) {
        socket.on('updateQr', data => {
          this.qr = data.qr
        })
      },
      _listenLockPassport (socket) {
        socket.on('unlockPassport', () => {
          if (!this.locked) {
            return
          }

          this.locked = false

          setTimeout(() => {
            this.locked = true
          }, Config.lockPassportTime)
        })
      }
    },
    computed: {
      imageQr () {
        return this.qr
      },
      session () {
        return this.$store.getters.session || { user: { email: null, token: null } }
      },
      qrMarginTop () {
        return Config.qrMarginTop
      },
      unlockText () {
        return Config.lockPassportText
      },
      lockPassport () {
        return Config.lockPassport || false
      }
    }
  }
</script>

<style>
@import '../assets/css/passport.css';
</style>
